import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookieComponent } from './cookie.component';
import { CookieConfig } from './cookie-config/cookie-config';
import { TranslationModule } from '../translation/translation.module';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';

@NgModule({
    declarations: [CookieComponent],
    imports: [CommonModule, TranslationModule, FormsModule, MatCheckboxModule,MatIconModule],
    exports: [CookieComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
      providers: [
            {
                provide: MAT_DIALOG_DEFAULT_OPTIONS,
                useValue: { hasBackdrop: true }
            }
        ]
})
export class CookieModule {
    static forRoot(clientConfig?: CookieConfig): ModuleWithProviders<CookieModule> {
        const finalConfig = new CookieConfig();
        if (clientConfig) {
            if (clientConfig.url) finalConfig.url = clientConfig.url;
        }
        return {
            ngModule: CookieModule,
            providers: [
                {
                    provide: CookieConfig,
                    useValue: finalConfig
                }
            ]
        };
    }
}
